import React from 'react';

export const renderChildren = (children, params) => React.Children.map(children, child => {
  if (React.isValidElement(child)) {
    return React.cloneElement(child, params);
  }
  return child;
});
